<!-- src/views/new-tip/VisitDetail.vue -->
<template>
  <v-container fluid v-if="visit">
    <div class="d-flex align-center mb-4">
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div class="ml-2">
        <h1 class="text-h5 font-weight-medium">Visite #{{ visit.id }}</h1>
        <span class="text-caption grey--text">
          Soumise {{ formatDateTime(visit.submitted_at) }}
        </span>
      </div>
      <v-spacer />
      <new-tip-status-badge type="visit" :value="visit.status" large />
    </div>

    <v-row>
      <!-- Colonne gauche : réponses + gains + actions -->
      <v-col cols="12" md="5">
        <v-card outlined class="mb-4">
          <v-card-title class="text-subtitle-1">Identité</v-card-title>
          <v-divider />
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Campagne</v-list-item-subtitle>
                <v-list-item-title>{{ visit.campaign ? visit.campaign.name : '—' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Superviseur</v-list-item-subtitle>
                <v-list-item-title>{{ visit.supervisor ? visit.supervisor.name : '—' }}
                  <span class="text-caption grey--text" v-if="visit.supervisor">· {{ visit.supervisor.phone }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>POS</v-list-item-subtitle>
                <v-list-item-title>{{ visit.salepoint ? visit.salepoint.name : '—' }}
                  <span class="text-caption grey--text" v-if="visit.salepoint">· {{ visit.salepoint.code }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>

        <v-card outlined class="mb-4">
          <v-card-title class="text-subtitle-1">Réponses</v-card-title>
          <v-divider />
          <v-list dense>
            <v-list-item>
              <v-list-item-content><v-list-item-subtitle>Planogramme respecté</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action>{{ formatBoolean(visit.planogram_respected) }}</v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-subtitle>PLV installée et visible</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action>{{ formatBoolean(visit.plv_installed_visible) }}</v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-subtitle>Stock GOB</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action>{{ visit.gob_stock_qty }} paquets</v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-subtitle>Stock West</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action>{{ visit.west_stock_qty }} paquets</v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-subtitle>Stock GUB</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action>{{ visit.gub_stock_qty }} paquets</v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-subtitle>Chapeau collector</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action>{{ formatBoolean(visit.hats_collected) }}</v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>

        <v-card outlined class="mb-4">
          <v-card-title class="text-subtitle-1">Gains de cette visite</v-card-title>
          <v-divider />
          <v-list dense>
            <v-list-item><v-list-item-content><v-list-item-subtitle>GOB</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action :class="visit.gains.gob > 0 ? 'success--text font-weight-medium' : 'grey--text'">{{ formatNumber(visit.gains.gob) }} pts</v-list-item-action></v-list-item>
            <v-list-item><v-list-item-content><v-list-item-subtitle>West</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action :class="visit.gains.west > 0 ? 'success--text font-weight-medium' : 'grey--text'">{{ formatNumber(visit.gains.west) }} pts</v-list-item-action></v-list-item>
            <v-list-item><v-list-item-content><v-list-item-subtitle>GUB</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action :class="visit.gains.gub > 0 ? 'success--text font-weight-medium' : 'grey--text'">{{ formatNumber(visit.gains.gub) }} pts</v-list-item-action></v-list-item>
            <v-list-item><v-list-item-content><v-list-item-subtitle>Chapeau</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action :class="visit.gains.hats > 0 ? 'success--text font-weight-medium' : 'grey--text'">{{ formatNumber(visit.gains.hats) }} pts</v-list-item-action></v-list-item>
            <v-divider />
            <v-list-item class="primary lighten-5">
              <v-list-item-content><v-list-item-title class="font-weight-bold">Total</v-list-item-title></v-list-item-content>
              <v-list-item-action class="text-h6 primary--text">{{ formatNumber(visit.gains.total) }} pts</v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>

        <!-- Récompense Gifty -->
        <v-card outlined class="mb-4" :color="visit.rewarded ? 'purple lighten-5' : ''">
          <v-card-title class="text-subtitle-1">
            <v-icon left :color="visit.rewarded ? 'purple' : 'grey'">mdi-gift</v-icon>
            Récompense Gifty
          </v-card-title>
          <v-divider />
          <v-card-text>
            <div v-if="visit.rewarded">
              <div class="text-caption grey--text">Transaction</div>
              <div class="font-weight-medium">{{ visit.gifty_transaction_id }}</div>
              <div class="text-caption grey--text mt-2">Date du transfert</div>
              <div>{{ formatDateTime(visit.rewarded_at) }}</div>
            </div>
            <div v-else-if="visit.status === 'validated'" class="text-caption grey--text">
              <v-icon small color="orange" class="mr-1">mdi-clock-outline</v-icon>
              Transfert en cours via la queue (TransferToGiftyJob).
            </div>
            <div v-else class="text-caption grey--text">
              La récompense sera transférée après validation par l'admin.
            </div>
          </v-card-text>
        </v-card>

        <!-- Actions Review -->
        <v-card outlined v-if="visit.status === 'submitted'">
          <v-card-title class="text-subtitle-1">Action admin</v-card-title>
          <v-divider />
          <v-card-text>
            <v-btn block color="success" :loading="saving" @click="confirmValidate">
              <v-icon left>mdi-check</v-icon> Valider la visite
            </v-btn>
            <v-btn block outlined color="error" class="mt-2" @click="rejectDialog = true">
              <v-icon left>mdi-close</v-icon> Rejeter la visite
            </v-btn>
          </v-card-text>
        </v-card>

        <v-alert v-else-if="visit.status === 'rejected'" type="error" outlined class="mt-2">
          <strong>Motif du rejet :</strong>
          <div>{{ visit.rejection_reason || '(non précisé)' }}</div>
        </v-alert>
      </v-col>

      <!-- Colonne droite : photos + carte -->
      <v-col cols="12" md="7">
        <v-card outlined class="mb-4">
          <v-card-title class="text-subtitle-1">Photos</v-card-title>
          <v-divider />
          <v-card-text>
            <new-tip-visit-photos-gallery :photos="visit.photos || {}" />
          </v-card-text>
        </v-card>

        <v-card outlined>
          <v-card-title class="text-subtitle-1">Géolocalisation</v-card-title>
          <v-divider />
          <new-tip-map-preview
            :latitude="visit.latitude" :longitude="visit.longitude" :accuracy="visit.gps_accuracy"
          />
          <v-card-text v-if="visit.latitude" class="text-caption grey--text">
            {{ visit.latitude }}, {{ visit.longitude }}
            <span v-if="visit.gps_accuracy"> · précision {{ Math.round(visit.gps_accuracy) }} m</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog rejet -->
    <v-dialog v-model="rejectDialog" max-width="500">
      <v-card>
        <v-card-title>Rejeter la visite</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="rejectionReason" label="Motif du rejet *"
            outlined dense rows="3" auto-grow
            :rules="[v => !!v || 'Le motif est obligatoire']"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="rejectDialog = false">Annuler</v-btn>
          <v-btn color="error" :loading="saving" :disabled="!rejectionReason" @click="confirmReject">
            Rejeter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { formatDateTime, formatNumber, formatBoolean } from '@/helpers/formatters';
import StatusBadge from '@/components/new-tip/StatusBadge.vue';
import VisitPhotosGallery from '@/components/new-tip/VisitPhotosGallery.vue';
import MapPreview from '@/components/new-tip/MapPreview.vue';

export default {
  name: 'NewTipVisitDetail',
  components: {
    'new-tip-status-badge': StatusBadge,
    'new-tip-visit-photos-gallery': VisitPhotosGallery,
    'new-tip-map-preview': MapPreview,
  },
  props: { id: { type: [String, Number], required: true } },
  data() { return { rejectDialog: false, rejectionReason: '' }; },
  computed: {
    ...mapState('newTip', { visit: s => s.currentVisit }),
    saving() { return this.$store.getters['newTip/isLoading']('saving'); },
  },
  methods: {
    ...mapActions('newTip', ['fetchVisit', 'reviewVisit']),
    formatDateTime, formatNumber, formatBoolean,

    async confirmValidate() {
      if (!confirm('Valider cette visite ? Le transfert Gifty sera dispatché automatiquement.')) return;
      await this.reviewVisit({ id: this.id, action: 'validate' });
    },
    async confirmReject() {
      await this.reviewVisit({ id: this.id, action: 'reject', rejectionReason: this.rejectionReason });
      this.rejectDialog = false;
      this.rejectionReason = '';
    },
  },
  mounted() { this.fetchVisit(this.id); },
};
</script>
